<div
  class="w-full h-full"
  [class]="
    fullScreen()
      ? 'surface-lowest fixed bottom-0 left-0 right-0 top-0 z-[109] p-2'
      : ''
  "
  [style.opacity]="
    showSkeleton() || (dataSourceBuilt() && columnsWithSet()) ? '1' : '0'
  "
  [id]="'siaTableFullScreen' + gridId()"
  [class.loading]="showSkeleton()"
  [class.loading-table]="showBodySkeleton()"
>
  <div
    class="flex flex-row items-center w-full"
    #searchAndActions
    [class]="
      enableGlobalFilterPanel() || showActions() || fullScreen()
        ? 'pb-2'
        : 'hidden'
    "
    [class.m-2]="!showActions()"
  >
    @if (
      enableGlobalFilterPanel() &&
      (!showTemplate() || !configuration().template)
    ) {
      <sia-search-box
        fontSize="1rem"
        iconSize="24px"
        [searchExp]="globalFilter()"
        (searchExpChange)="globalFilter.set($event); applyGlobalFilter()"
        (searchClicked)="applyGlobalFilter()"
        class="w-1/5 min-w-[200px]"
      >
      </sia-search-box>
    }
    @if ((showActions() || fullScreen()) && actionsPageData()) {
      <div
        [class]="
          enableGlobalFilterPanel() &&
          (!showTemplate() || !configuration().template)
            ? 'w-4/5'
            : 'w-full'
        "
        #gridActions
      >
        @if (!pageData()?.outlet?.includes('drawer') || fullScreen()) {
          <sia-actions-container
            [parentWidth]="gridActions.offsetWidth"
            [pageData]="actionsPageData()"
            [buttonsSize]="'medium'"
          >
          </sia-actions-container>
        } @else {
          <sia-actions-container
            [parentWidth]="gridActions.offsetWidth"
            [pageData]="actionsPageData()"
            [buttonsSize]="'small'"
            [compact]="false"
            [onlyIcons]="true"
          >
          </sia-actions-container>
        }
      </div>
    }
  </div>
  <div class="w-full h-fit" #templateSearch>
    @if (showTemplate() && configuration().template) {
      <div class="sticky top-0 flex w-full gap-2 px-1 py-1">
        <div class="w-full">
          <sia-search-box
            fontSize="1rem"
            iconSize="24px"
            [searchExp]="globalFilter()"
            (searchExpChange)="globalFilter.set($event); applyGlobalFilter()"
            (searchClicked)="applyGlobalFilter()"
          >
          </sia-search-box>
        </div>
        <div
          class="bg-secondary-container flex min-w-fit flex-col items-center justify-center gap-[0.125rem] rounded-lg px-1 py-[0.125rem] text-xs"
        >
          <span>Nr. record</span>
          <span> {{ totalCount() }}</span>
        </div>
      </div>
    }
  </div>
  @if (groupByChips() && groupByChips().length > 0) {
    <div
      class="flex h-[52px] max-h-[52px] w-full items-center gap-2 overflow-x-auto px-2"
    >
      <span class="text-lg font-semibold text-secondary">
        {{ 'Raggruppamento:' | siaTranslate }}
      </span>
      <mat-chip-listbox>
        <mat-chip
          [id]="groupByChips()[0].name"
          class="!bg-secondary-container"
          [matMenuTriggerFor]="groupByMenuEnabled() ? groupByMenu : null"
          (contextmenu)="openGroupByMenu($event, groupByMenuTrigger)"
          #groupByMenuTrigger="matMenuTrigger"
        >
          {{ groupByChips()[0].name | siaTranslate }}
        </mat-chip>
      </mat-chip-listbox>

      <mat-menu #groupByMenu="matMenu">
        @for (col of groupingColumns(); track $index) {
          @if (col.colConfig.allowGrouping) {
            <ng-container>
              <button mat-menu-item (click)="swapGroupByColumn(col)">
                {{ col.headerName | siaTranslate | breakLine: false }}
              </button>
            </ng-container>
          }
        }
      </mat-menu>
    </div>
  }
  @if (!showTemplate() || !configuration().template) {
    <div
      class="sia-mat-grid-table"
      [id]="gridId()"
      [style]="
        'height: calc(100% - ' +
        (paginator.offsetHeight +
          searchAndActions.offsetHeight +
          templateSearch.offsetHeight +
          (fullScreen() ? 8 : 0) +
          (hasFilterPanel() && pageData()?.outlet?.includes('drawer') ? 8 : 0) +
          (groupByChips() && groupByChips().length > 0 ? 52 : 0)) +
        'px)'
      "
      [class.!overflow-hidden]="showBodySkeleton()"
    >
      <table
        mat-table
        fixedLayout
        [id]="'siaTable' + gridId()"
        [trackBy]="trackByFn"
      >
        <tr
          mat-header-row
          *matHeaderRowDef="columnsIds(); sticky: true"
          class="main-header-row"
          [hidden]="compactViewActive() && !showHeaderGrid()"
        ></tr>
        <tr
          class="sia-mat-grid-filter-row"
          mat-header-row
          *matHeaderRowDef="filterColumnsIds(); sticky: true"
          [hidden]="
            !configuration().filterRowEnabled ||
            (compactViewActive() && !showHeaderGrid()) ||
            hideHeaderFilters()
          "
        ></tr>
        <tr
          mat-row
          *matRowDef="
            let row;
            columns: columnsIds();
            when: isNotGroup;
            let i = index;
            let last = last
          "
          [class]="last ? 'sia-empty-row' : 'sia-row'"
          (ngInit)="
            last
              ? getEmptyRowHeight()
              : i == lastRowClickedIndex()
                ? scrollGrid(i)
                : false
          "
          [isLast]="true"
          [style.display]="
            (compactViewActive() && last) ||
            (compactViewActive() && i != lastRowClickedIndex())
              ? 'none'
              : ''
          "
          [id]="gridId() + '-row-' + i"
        ></tr>
        <tr
          mat-footer-row
          *matFooterRowDef="columnsIds(); sticky: true; let i = index"
          [hidden]="!haveTotals() || compactViewActive()"
        ></tr>
        <ng-container matColumnDef="groupHeader">
          <td colspan="999" mat-cell *matCellDef="let group">
            <div
              class="!flex flex-row items-center gap-2"
              [style.padding-left.px]="group.groupLevel * 32"
            >
              <button mat-icon-button>
                <mat-icon>
                  @if (group.reduced) {
                    expand_less
                  } @else {
                    expand_more
                  }
                </mat-icon>
              </button>
              <span class="text-lg font-semibold">{{ group.groupName }}</span>
              <div class="flex-1"></div>
              @if (configuration().group?.groupActions) {
                @if (configuration().group?.groupActions?.length === 1) {
                  @for (
                    action of configuration().group?.groupActions;
                    track $index
                  ) {
                    <button
                      mat-icon-button
                      [matTooltip]="action.tooltip ?? '' | siaTranslate"
                      (click)="
                        execScript(action.script ?? '', group);
                        $event.stopPropagation()
                      "
                    >
                      <mat-icon [class]="getIconClass(action.icon)">{{
                        action.icon
                      }}</mat-icon>
                    </button>
                  }
                } @else if (
                  (configuration().group?.groupActions?.length ?? 0) > 1
                ) {
                  <button
                    mat-icon-button
                    [matMenuTriggerFor]="groupActionsMenu"
                    [matTooltip]="'azioni gruppo' | siaTranslate"
                    (click)="$event.stopPropagation()"
                  >
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #groupActionsMenu="matMenu">
                    @for (
                      action of configuration().group?.groupActions;
                      track $index
                    ) {
                      <button
                        mat-menu-item
                        (click)="execScript(action.script ?? '', group)"
                      >
                        <mat-icon [class]="getIconClass(action.icon)">{{
                          action.icon
                        }}</mat-icon>
                        <span>{{
                          action.tooltip ?? action.icon | siaTranslate
                        }}</span>
                      </button>
                    }
                  </mat-menu>
                }
              }
            </div>
          </td>
        </ng-container>
        <tr
          mat-row
          class="sia-mat-grid-group-row sia-row"
          *matRowDef="
            let row;
            columns: ['groupHeader'];
            when: isGroup;
            let i = index
          "
          (click)="reduceGroup(row)"
        ></tr>

        <ng-container matColumnDef="__selection-column">
          <th
            mat-header-cell
            *matHeaderCellDef
            [style.text-align]="'center'"
            class="sia-mat-grid-header-row"
            [style.width]="'75px'"
          >
            @if (
              configuration().selectionMode == 'multiple' && allowSelectAll()
            ) {
              <mat-checkbox
                (change)="$event ? toggleAllRows() : null"
                [checked]="selectedRows()?.hasValue() && isAllSelected()"
                [indeterminate]="selectedRows()?.hasValue() && !isAllSelected()"
                [aria-label]="checkboxLabel()"
              >
              </mat-checkbox>
            }
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            [style.text-align]="'center'"
            [style.width]="'75px'"
          >
            @if (checkActionSelection(row)) {
              <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="
                  $event ? selectedRows()?.toggle(rowToJson(row)) : null
                "
                [checked]="
                  isAllSelected() || selectedRows()?.isSelected(rowToJson(row))
                "
                [aria-label]="checkboxLabel(row)"
              >
              </mat-checkbox>
            }
          </td>
          <td mat-footer-cell *matFooterCellDef [style.width]="'75px'"></td>
        </ng-container>

        <ng-container matColumnDef="__action-column">
          <th
            mat-header-cell
            *matHeaderCellDef
            [style.text-align]="'center'"
            class="sia-mat-grid-header-row"
            [style.width]="'90px'"
          ></th>
          <td mat-cell *matCellDef="let row" [style.width]="'90px'">
            <div
              class="!flex w-full !flex-row flex-nowrap justify-center gap-1"
            >
              @if (!row['__editing']) {
                <button mat-icon-button (click)="editRow(row)" class="small">
                  <mat-icon>edit</mat-icon>
                </button>
                <button
                  mat-icon-button
                  class="error small"
                  (click)="deleteRow(row)"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              } @else {
                <button mat-icon-button (click)="saveEdits(row)" class="small">
                  <mat-icon>save</mat-icon>
                </button>
                <button
                  mat-icon-button
                  (click)="declineChanges(row)"
                  class="small"
                >
                  <mat-icon>undo</mat-icon>
                </button>
              }
            </div>
          </td>
          <td mat-footer-cell *matFooterCellDef [style.width]="'75px'"></td>
        </ng-container>
        <ng-container matColumnDef="__focus-row-column">
          <th
            mat-header-cell
            *matHeaderCellDef
            [style.text-align]="'center'"
            class="sia-mat-grid-header-row"
            [hidden]="hideArrows()"
            [style.width]="'60px'"
          ></th>

          <td
            mat-cell
            *matCellDef="let row; let i = index"
            class="text-center cursor-pointer"
            [style.text-align]="'center'"
            (click)="toggleRowFromIndex(row['__initialRowIndex'] ?? i)"
            [hidden]="hideArrows()"
            [style.width]="'60px'"
          >
            <mat-icon>{{
              lastRowClickedIndex() == (row['__initialRowIndex'] ?? i) &&
              compact()
                ? 'keyboard_arrow_up'
                : 'keyboard_arrow_down'
            }}</mat-icon>
          </td>
          <td mat-footer-cell *matFooterCellDef [style.width]="'60px'"></td>
        </ng-container>
        @for (number of numberGroups(); track number) {
          <ng-container [matColumnDef]="'group' + number">
            <th
              mat-header-cell
              *matHeaderCellDef
              [style.text-align]="'center'"
              class="sia-mat-grid-header-row"
              [hidden]="hideArrows()"
              [style.width]="'32px'"
            ></th>
            <td
              mat-cell
              *matCellDef="let row; let i = index"
              class="text-center cursor-pointer"
              [style.text-align]="'center'"
              (click)="toggleRowFromIndex(row['__initialRowIndex'] ?? i)"
              [hidden]="hideArrows()"
              [style.width]="'32px'"
            ></td>
            <td mat-footer-cell *matFooterCellDef [style.width]="'32px'"></td>
          </ng-container>
        }

        @for (column of columns(); track column.id; let last = $last) {
          <ng-container [matColumnDef]="column.id">
            <th
              mat-header-cell
              *matHeaderCellDef
              [resizeColumn]="true"
              [(columnConfig)]="column.colConfig"
              [gridId]="gridId()"
              class="sia-mat-grid-header-row"
              [class]="column.colConfig.headerClass ?? getHeaderClass(column)"
              [siaTooltip]="column.colConfig.toolTip ?? ''"
              (click)="sortColumn(column)"
              [style]="column.colConfig.allowSorting ? 'cursor: pointer' : ''"
              [style.width]="
                column.colConfig.currentWidth
                  ? column.colConfig.currentWidth + 'px'
                  : ''
              "
              (ngInit)="last ? resetColumnWidths() : false"
              [isLast]="last"
            >
              @if (!compactViewActive()) {
                <div class="sia-mat-grid-header-actions">
                  @if (column.orderByDirection) {
                    <div class="sia-mat-grid-header-actions__action">
                      <mat-icon
                        class="sia-mat-grid-header-actions__action--applied"
                      >
                        {{
                          column.orderByDirection == 'asc'
                            ? 'arrow_upward'
                            : 'arrow_downward'
                        }}
                      </mat-icon>
                      {{ column.sortIndex }}
                    </div>
                  } @else {
                    <div class="sia-mat-grid-header-actions__action">
                      <mat-icon
                        class="sia-mat-grid-header-actions__action--not-applied"
                      >
                        swap_vert
                      </mat-icon>
                    </div>
                  }
                  @if (column.colConfig.allowHeaderFiltering) {
                    <div class="sia-mat-grid-header-actions__action">
                      @if (
                        column.headerFilterValue &&
                        column.headerFilterValue.length
                      ) {
                        {{
                          column.headerFilterValue.length <= 99
                            ? column.headerFilterValue.length
                            : '99+'
                        }}
                      }
                      <mat-icon
                        stopClickPropagation
                        #menuTrigger="matMenuTrigger"
                        [matMenuTriggerFor]="headerFilterMenu"
                        (click)="
                          openHeaderFilterList(column.colConfig, menuTrigger)
                        "
                        [class]="
                          column.headerFilterValue &&
                          column.headerFilterValue.length
                            ? 'sia-mat-grid-header-actions__action--applied'
                            : ''
                        "
                      >
                        filter_list
                      </mat-icon>
                    </div>

                    <mat-menu #headerFilterMenu="matMenu" xPosition="before">
                      <ng-template matMenuContent>
                        <div class="h-[400px] w-[280px]" stopClickPropagation>
                          @if (showHeaderFilterSpinner()) {
                            <div class="sia-flex-center sia-blur">
                              <mat-spinner></mat-spinner>
                            </div>
                          } @else {
                            @if (
                              column.headerFilterDataSource &&
                              column.headerFilterDataSource.length > 0
                            ) {
                              <button
                                stopClickPropagation
                                class="w-full"
                                [class]="
                                  hasSelected(column.headerFilterDataSource)
                                    ? 'error'
                                    : ''
                                "
                                mat-button
                                (click)="toggleHeaderFilterSelection(column)"
                              >
                                <mat-icon>{{
                                  hasSelected(column.headerFilterDataSource)
                                    ? 'mop'
                                    : 'select_all'
                                }}</mat-icon>
                                {{
                                  hasSelected(column.headerFilterDataSource)
                                    ? ('Deseleziona' | siaTranslate)
                                    : ('Seleziona' | siaTranslate)
                                }}
                              </button>

                              <div
                                class="flex flex-col gap-2 overflow-auto"
                                [style]="
                                  'height: calc(400px - ' + 40 * 2 + 'px)'
                                "
                              >
                                @if (
                                  headerValuesWithData()[column.id] &&
                                  headerValuesWithData()[column.id].length > 0
                                ) {
                                  <div
                                    class="px-2 text-xs font-semibold text-secondary"
                                  >
                                    {{ 'Filtri con dati' | siaTranslate }}
                                  </div>
                                }
                                @for (
                                  filterItem of headerValuesWithData()[
                                    column.id
                                  ];
                                  track filterItem.id
                                ) {
                                  <div
                                    class="sia-hover"
                                    mat-menu-item
                                    stopClickPropagation
                                    (click)="
                                      selectHeaderFilterItem(
                                        $event,
                                        column,
                                        filterItem.id
                                      )
                                    "
                                  >
                                    <div class="flex flex-row items-center">
                                      <sia-check-box
                                        [value]="filterItem.selected"
                                        [disabled]="true"
                                        (click)="
                                          selectHeaderFilterItem(
                                            $event,
                                            column,
                                            filterItem.id
                                          )
                                        "
                                        class="!w-fit"
                                      ></sia-check-box>
                                      {{
                                        getDescription(filterItem.description)
                                      }}
                                    </div>
                                  </div>
                                }
                                @if (
                                  headerValuesWithoutData()[column.id] &&
                                  headerValuesWithoutData()[column.id].length >
                                    0
                                ) {
                                  @if (
                                    headerValuesWithData()[column.id].length > 0
                                  ) {
                                    <mat-divider class="my-1"></mat-divider>
                                  }

                                  <div
                                    class="px-2 text-xs font-semibold text-secondary"
                                  >
                                    {{ 'Filtri senza dati' | siaTranslate }}
                                  </div>
                                }
                                @for (
                                  filterItem of headerValuesWithoutData()[
                                    column.id
                                  ];
                                  track filterItem.id
                                ) {
                                  <div
                                    class="sia-hover"
                                    mat-menu-item
                                    stopClickPropagation
                                    (click)="
                                      selectHeaderFilterItem(
                                        $event,
                                        column,
                                        filterItem.id
                                      )
                                    "
                                  >
                                    <div class="flex flex-row items-center">
                                      <sia-check-box
                                        [value]="filterItem.selected"
                                        [disabled]="true"
                                        (click)="
                                          selectHeaderFilterItem(
                                            $event,
                                            column,
                                            filterItem.id
                                          )
                                        "
                                        class="!w-fit"
                                      ></sia-check-box>
                                      {{
                                        getDescription(filterItem.description)
                                      }}
                                    </div>
                                  </div>
                                }
                              </div>
                              <button
                                mat-flat-button
                                class="mx-2 w-[calc(100%-1rem)]"
                                (click)="applyHeaderColumnFilter(column)"
                              >
                                {{ 'Applica' | siaTranslate }}
                              </button>
                            }
                          }
                        </div>
                      </ng-template>
                    </mat-menu>
                  }
                </div>
              }
              <div
                [innerHTML]="
                  column.headerName
                    ? (column.headerName | siaTranslate | breakLine)
                    : (column.headerName | breakLine)
                "
                class="text-center sia-mat-grid-header"
                [class]="'sia-mat-grid-header-' + column.id"
              ></div>
            </th>
            <td
              mat-cell
              #cellElement
              *matCellDef="let element; let i = index"
              [style.text-align]="
                element['__editing']
                  ? 'center'
                  : (column?.colConfig?.alignment ?? 'left')
              "
              [style]="styleSignals()[i + '_' + column.id]?.style"
              [colorContrastAuto]="column.colConfig.contrastColor ?? false"
              [contrastMode]="column.colConfig.contrastMode ?? 'auto'"
              [class]="
                element[column?.id + '__errorMessage'] != undefined
                  ? '!text-error'
                  : (styleSignals()[i + '_' + column.id]?.class ?? '')
              "
              (click)="
                cellClick(
                  element,
                  element['__initialRowIndex'] ?? i,
                  column.colConfig
                )
              "
              [siaTooltip]="
                element[column?.id + '__errorMessage'] != undefined
                  ? element[column?.id + '__errorMessage']
                  : column.colConfig.actionTooltip
              "
              [style.width]="
                column.colConfig.currentWidth
                  ? column.colConfig.currentWidth + 'px'
                  : ''
              "
            >
              @switch (column.colConfig.dataType) {
                @case ('icon') {
                  @if (element['__editing'] && column.colConfig.allowEditing) {
                    <sia-text-box
                      [(value)]="element[column?.id ?? '']"
                      [status]="element[column?.id + '__errorStatus']"
                      (valueChanged)="valueChanged($event, column, element)"
                    ></sia-text-box>
                  } @else {
                    <mat-icon
                      [style]="styleSignals()[i + '_' + column.id]?.style"
                      [colorContrastAuto]="
                        column.colConfig.contrastColor ?? false
                      "
                      [contrastMode]="column.colConfig.contrastMode ?? 'auto'"
                    >
                      {{ element[column?.id ?? ''] }}</mat-icon
                    >
                  }
                }
                @case ('avatar') {
                  <sia-cell-avatar
                    [width]="32"
                    [userId]="element[column?.id ?? '']"
                  >
                  </sia-cell-avatar>
                }
                @case ('image') {
                  @if (column.colConfig.imageSourceType === 'url') {
                    <img
                      [style.height]="column.colConfig.imageHeight ?? '20px'"
                      [src]="element[column?.id ?? '']"
                    />
                  } @else {
                    <img
                      [style.height]="column.colConfig.imageHeight ?? '20px'"
                      [src]="element[column?.id ?? '']"
                    />
                  }
                }
                @case ('svg') {
                  <div
                    class="flex h-full w-full items-center justify-center [&_svg]:h-full [&_svg]:w-auto"
                    [style.height]="column.colConfig.imageHeight ?? '20px'"
                    [innerHTML]="element[column?.id ?? ''] | safeHtml"
                  ></div>
                }
                @case ('string') {
                  @if (element['__editing'] && column.colConfig.allowEditing) {
                    @if (column.colConfig.useSelectBox) {
                      <sia-select-box
                        (valueChanged)="valueChanged($event, column, element)"
                        [(value)]="element[column?.id ?? '']"
                        [selectBoxOptions]="{
                          dbKey:
                            column.colConfig.viewSchema +
                            '.' +
                            column.colConfig.viewName,
                          value: element[column?.id ?? ''],
                        }"
                        [status]="element[column?.id + '__errorStatus']"
                      >
                      </sia-select-box>
                    } @else {
                      <sia-text-box
                        (valueChanged)="valueChanged($event, column, element)"
                        [(value)]="element[column?.id ?? '']"
                        [status]="element[column?.id + '__errorStatus']"
                      ></sia-text-box>
                    }
                  } @else {
                    @if (column?.colConfig?.translate) {
                      <span
                        [style]="element['span-style_' + column?.id]"
                        overflowTooltip
                        [overflowTooltip]="element[column.id]"
                        [canBeTranslated]="true"
                      >
                        {{
                          isPrimaryKeyToIdentifyWithHashtag(column?.id)
                            ? '#'
                            : ''
                        }}
                        {{ element[column?.id ?? ''] | siaTranslate }}
                      </span>
                    } @else {
                      <span
                        [style]="element['span-style_' + column?.id]"
                        overflowTooltip
                        [overflowTooltip]="element[column.id]"
                      >
                        {{
                          isPrimaryKeyToIdentifyWithHashtag(column?.id)
                            ? '#'
                            : ''
                        }}
                        {{ element[column?.id ?? ''] }}
                      </span>
                    }
                  }
                }
                @case ('color') {
                  @if (element['__editing'] && column.colConfig.allowEditing) {
                    <sia-color-box
                      (valueChanged)="valueChanged($event, column, element)"
                      [(value)]="element[column?.id ?? '']"
                      [status]="element[column?.id + '__errorStatus']"
                    >
                    </sia-color-box>
                  } @else {
                    <span
                      [style]="element['span-style_' + column?.id]"
                      overflowTooltip
                      [overflowTooltip]="element[column.id]"
                    >
                      {{
                        isPrimaryKeyToIdentifyWithHashtag(column?.id) ? '#' : ''
                      }}
                      {{ element[column?.id ?? ''] }}
                    </span>
                  }
                }
                @case ('number') {
                  @if (element['__editing'] && column.colConfig.allowEditing) {
                    @if (column.colConfig.useSelectBox) {
                      <sia-select-box
                        (valueChanged)="valueChanged($event, column, element)"
                        [(value)]="element[column?.id ?? '']"
                        [selectBoxOptions]="{
                          dbKey:
                            column.colConfig.viewSchema +
                            '.' +
                            column.colConfig.viewName,
                          value: element[column?.id ?? ''],
                        }"
                        [status]="element[column?.id + '__errorStatus']"
                      >
                      </sia-select-box>
                    } @else {
                      <sia-number-box
                        (valueChanged)="valueChanged($event, column, element)"
                        [(value)]="element[column?.id ?? '']"
                        [status]="element[column?.id + '__errorStatus']"
                      ></sia-number-box>
                    }
                  } @else {
                    <span>
                      {{
                        isPrimaryKeyToIdentifyWithHashtag(column.id) ? '#' : ''
                      }}
                      {{
                        element[column?.id ?? ''] ?? ''
                          | formatNumber: column.colConfig.format
                      }}
                    </span>
                  }
                }
                @case ('action') {
                  @if (
                    column.colConfig.actionText ||
                    column.colConfig.actionTextScript
                  ) {
                    <button
                      mat-stroked-button
                      style="z-index: 0"
                      class="sia-mat-grid-action"
                      style="display: inline-block !important"
                      [style]="
                        (!element['icon_' + column?.id] ||
                          element['icon_' + column?.id] == ' ') &&
                        (!element['text_' + column?.id] ||
                          element['text_' + column?.id] == ' ')
                          ? 'display: none !important'
                          : ''
                      "
                    >
                      @if (
                        column.colConfig.actionIcon ||
                        column.colConfig.actionIconScript
                      ) {
                        <mat-icon>
                          {{ element['icon_' + column?.id] }}
                        </mat-icon>
                      }
                      {{ element['text_' + column?.id] | siaTranslate }}
                    </button>
                  }
                  @if (
                    !column.colConfig.actionText &&
                    !column.colConfig.actionTextScript
                  ) {
                    <button
                      mat-icon-button
                      style="z-index: 0"
                      class="sia-mat-grid-action"
                      style="display: inline-block !important"
                      [style]="
                        (!element['icon_' + column?.id] ||
                          element['icon_' + column?.id] == ' ') &&
                        (!element['text_' + column?.id] ||
                          element['text_' + column?.id] == ' ')
                          ? 'display: none !important'
                          : ''
                      "
                    >
                      @if (
                        column.colConfig.actionIcon ||
                        column.colConfig.actionIconScript
                      ) {
                        <mat-icon>
                          {{
                            element['icon_' + column?.id]
                              ? element['icon_' + column?.id]
                              : getActionIcon(element, column.colConfig)
                          }}
                        </mat-icon>
                      }
                    </button>
                  }
                }
                @case ('date') {
                  @if (element['__editing'] && column.colConfig.allowEditing) {
                    <sia-datetime-box
                      [(value)]="element[column?.id ?? '']"
                      (valueChanged)="valueChanged($event, column, element)"
                      type="date"
                      [status]="element[column?.id + '__errorStatus']"
                    ></sia-datetime-box>
                  } @else {
                    {{
                      element[column?.id ?? ''] ?? ''
                        | date: column.colConfig.format
                    }}
                  }
                }
                @case ('datetime') {
                  @if (element['__editing'] && column.colConfig.allowEditing) {
                    <div class="!flex !h-full !w-full !flex-col !gap-1">
                      <sia-datetime-box
                        class="w-full"
                        [(value)]="element[column?.id ?? '']"
                        (valueChanged)="valueChanged($event, column, element)"
                        [status]="element[column?.id + '__errorStatus']"
                        type="date"
                      ></sia-datetime-box>
                      <sia-time-box
                        (valueChanged)="valueChanged($event, column, element)"
                        class="w-full"
                        [status]="element[column?.id + '__errorStatus']"
                        [(value)]="element[column?.id ?? '']"
                      ></sia-time-box>
                    </div>
                  } @else {
                    {{
                      element[column?.id ?? ''] ?? ''
                        | date: column.colConfig.format
                    }}
                  }
                }
                @case ('boolean') {
                  @if (element['__editing'] && column.colConfig.allowEditing) {
                    <sia-check-box
                      (valueChanged)="valueChanged($event, column, element)"
                      color="warn"
                      [(value)]="element[column?.id ?? '']"
                      [status]="element[column?.id + '__errorStatus']"
                      [disabled]="false"
                    ></sia-check-box>
                  } @else {
                    <sia-check-box
                      color="accent"
                      [value]="element[column?.id ?? '']"
                      [disabled]="true"
                    ></sia-check-box>
                  }
                }
              }
            </td>
            <td
              mat-footer-cell
              *matFooterCellDef
              [style.width]="
                column.colConfig.currentWidth
                  ? column.colConfig.currentWidth + 'px'
                  : ''
              "
            >
              @if (column.colConfig.summaryColEnable) {
                <div class="sia-mat-grid-footer">
                  <span
                    [style.text-align]="column?.colConfig?.alignment ?? 'left'"
                  >
                    @if (column.colConfig.summaryScript) {
                      {{
                        column.colConfig.summaryScriptApplied
                          ? column.colConfig.summaryValue
                          : processSummaryScript(column.colConfig)
                      }}
                    } @else {
                      {{
                        column.colConfig.summaryValue
                          | formatNumber: column.colConfig.summaryDisplayFormat
                      }}
                    }
                  </span>
                </div>
              }
            </td>
          </ng-container>
          <ng-container [matColumnDef]="column.id + '-filter'">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="sia-mat-grid-filter-th filter-hearder-cell"
              [style.width]="
                column.colConfig.currentWidth
                  ? column.colConfig.currentWidth + 'px'
                  : ''
              "
            >
              @if (column.colConfig.allowFilter) {
                <div
                  class="sia-mat-grid-header-filter"
                  [class]="
                    column.filterValue
                      ? 'sia-mat-grid-header-filter--active'
                      : ''
                  "
                >
                  <mat-form-field
                    appearance="fill"
                    class="sia-mat-grid-header-filter__field sia-mat-grid-header-filter__field--select"
                    subscriptSizing="dynamic"
                  >
                    <mat-select
                      [(value)]="column.filterOperator"
                      (selectionChange)="applyFilters()"
                      panelClass="sia-mat-grid-header-filter__operator"
                    >
                      <mat-select-trigger>
                        <div
                          [innerHtml]="
                            getFilterHtml(column.filterOperator) | safeHtml
                          "
                        ></div>
                      </mat-select-trigger>
                      @for (
                        filterType of getFiltersByType(
                          column.colConfig.dataType ?? ''
                        );
                        track filterType
                      ) {
                        <mat-option [value]="filterType.id">
                          <div
                            [innerHtml]="filterType.htmlContent | safeHtml"
                          ></div>
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  @if (
                    column.colConfig.dataType != 'date' &&
                    column.colConfig.dataType != 'datetime'
                  ) {
                    <mat-form-field
                      class="sia-mat-grid-header-filter__field sia-mat-grid-header-filter__field--value"
                      subscriptSizing="dynamic"
                    >
                      <input
                        matInput
                        [type]="
                          column.colConfig.dataType === 'number'
                            ? 'number'
                            : 'text'
                        "
                        [(ngModel)]="column.filterValue"
                        (ngModelChange)="
                          !column.filterValue ? applyFilters() : null
                        "
                        (keydown.enter)="applyFilters()"
                        (blur)="applyFilters()"
                        autocomplete="off"
                      />
                    </mat-form-field>
                  }
                  @if (
                    column.colConfig.dataType == 'date' &&
                    column.filterOperator != 'between'
                  ) {
                    <sia-datetime-box
                      class="sia-mat-grid-header-filter__field sia-mat-grid-header-filter__field--value h-[36px]"
                      [(value)]="column.filterValue"
                      (valueChanged)="applyFilters()"
                    >
                    </sia-datetime-box>
                  }
                  @if (
                    column.colConfig.dataType == 'date' &&
                    column.filterOperator == 'between'
                  ) {
                    <mat-form-field
                      class="sia-mat-grid-header-filter__field sia-mat-grid-header-filter__field--value"
                      subscriptSizing="dynamic"
                      style="height: 36px"
                    >
                      <mat-date-range-input [rangePicker]="rangePicker">
                        <input
                          matStartDate
                          (dateChange)="dateRangeValueChange(column, $event, 0)"
                          disabled
                        />
                        <input
                          matEndDate
                          (dateChange)="dateRangeValueChange(column, $event, 1)"
                          disabled
                        />
                      </mat-date-range-input>
                      <mat-datepicker-toggle
                        matIconSuffix
                        [for]="rangePicker"
                      ></mat-datepicker-toggle>
                      <mat-date-range-picker
                        #rangePicker
                        disabled="false"
                      ></mat-date-range-picker>
                    </mat-form-field>
                  }
                </div>
              }
            </th>
          </ng-container>
        }
      </table>
    </div>
  } @else {
    <div
      #templateContainer
      siaScrollBottomNotify
      [threshold]="'400px'"
      (bottomReached)="loadTemplateData()"
      class="sia-mat-grid-table overflow-y-auto !overflow-x-hidden"
      [id]="gridId()"
      [style]="
        'height: calc(100% - ' +
        (paginatorHeight() +
          searchAndActions.offsetHeight +
          templateSearch.offsetHeight +
          (groupByChips() && groupByChips().length > 0 ? 52 : 0)) +
        'px)'
      "
    >
      @for (
        rowData of dataSource();
        track $index;
        let i = $index;
        let Last = $last
      ) {
        <div class="ml-2">
          @if (rowData.isGroup) {
            <div
              class="sia-mat-grid-group-row !flex flex-row items-center gap-2 p-1"
              (click)="reduceGroup(rowData)"
              [style.padding-left.px]="rowData.groupLeve * 8"
            >
              <button mat-icon-button>
                <mat-icon>
                  @if (rowData.reduced) {
                    expand_less
                  } @else {
                    expand_more
                  }
                </mat-icon>
              </button>
              <span class="text-lg font-semibold">{{
                rowData.groupName | siaTranslate
              }}</span>
              <div class="flex-1"></div>
              @if (rowData.groupLevel === 0) {
                @if (configuration().group?.groupActions) {
                  @if (configuration().group?.groupActions?.length === 1) {
                    @for (
                      action of configuration().group?.groupActions;
                      track $index
                    ) {
                      <button
                        mat-icon-button
                        [matTooltip]="action.tooltip ?? '' | siaTranslate"
                        (click)="
                          execScript(action.script ?? '', rowData);
                          $event.stopPropagation()
                        "
                      >
                        <mat-icon [class]="getIconClass(action.icon)">{{
                          action.icon
                        }}</mat-icon>
                      </button>
                    }
                  } @else if (
                    (configuration().group?.groupActions?.length ?? 0) > 1
                  ) {
                    <button
                      mat-icon-button
                      [matMenuTriggerFor]="groupActionsMenu"
                      [matTooltip]="'azioni gruppo' | siaTranslate"
                      (click)="$event.stopPropagation()"
                    >
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #groupActionsMenu="matMenu">
                      @for (
                        action of configuration().group?.groupActions;
                        track $index
                      ) {
                        <button
                          mat-menu-item
                          (click)="execScript(action.script ?? '', rowData)"
                        >
                          <mat-icon [class]="getIconClass(action.icon)">{{
                            action.icon
                          }}</mat-icon>
                          <span>{{
                            action.tooltip ?? action.icon | siaTranslate
                          }}</span>
                        </button>
                      }
                    </mat-menu>
                  }
                }
              }
            </div>
            <mat-divider class="h-[1px] w-full"></mat-divider>
          } @else {
            <sia-template-renderer
              [template]="configuration().template"
              [data]="rowData"
              [id]="gridId() + '-row-' + i"
              (click)="cellClick(rowData, i, undefined)"
              class="block w-full"
            ></sia-template-renderer>
            @if (configuration().showTemplateBorders) {
              <mat-divider class="h-[1px] w-full"></mat-divider>
            }
          }
        </div>
      }
    </div>
  }
  <div
    class="flex justify-center w-full"
    #paginator
    [style]="
      compactViewActive()
        ? 'display: none; height: 0px;'
        : 'height: fit-content'
    "
  >
    @if (!showTemplate() || !configuration().template) {
      <mat-paginator
        [hidePageSize]="compactViewActive()"
        [pageSizeOptions]="[20, 50, 100, 200, 500, 1000]"
        showFirstLastButtons
        [pageIndex]="currentPageIndex()"
        [pageSize]="currentPageSize()"
        (page)="pageChanged($event)"
        [length]="totalCount()"
        class="small-paginator"
      >
      </mat-paginator>
    } @else {
      <div
        class="flex flex-col items-center justify-center w-full bg-secondary-container"
      >
        @if (summaries()) {
          @for (item of summaries(); track $index) {
            <div class="flex w-full flex-row justify-end px-2 py-0.5">
              <span
                class="font-semibold"
                [innerHTML]="
                  item.colname
                    ? (item.colname | siaTranslate | breakLine: false)
                    : (item.colname | breakLine: false)
                "
              ></span
              >: <span>{{ item.result | formatNumber: item.format }}</span>
            </div>
            <mat-divider class="w-full"></mat-divider>
          }
        }
      </div>
    }
  </div>

  <div
    class="sia-side-panel sia-side-panel-background"
    [inert]="!columnChooserVisible()"
    outsideClick
    (clickedOutside)="toggleColumnChooserVisibility()"
    [outsideClickActive]="columnChooserVisible() && !showColumnChooserSpinner()"
    [outsideClickIgnore]="[]"
  >
    <div class="flex items-center justify-between" #filterHeader>
      <span class="text-2xl text-secondary">{{
        'Selettore colonne' | siaTranslate
      }}</span>
      <button mat-icon-button (click)="toggleColumnChooserVisibility()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div
      cdkScrollable
      class="flex flex-col overflow-auto"
      cdkDropList
      [cdkDropListData]="columnChooserColumns()"
      (cdkDropListDropped)="drop($event)"
    >
      @for (column of columnChooserColumns(); track column.id) {
        <div class="p-2 border-b border-solid cursor-move" cdkDrag>
          <sia-check-box
            [value]="column.selected"
            [label]="column.description | siaTranslate | breakLine: false"
            (valueChanged)="toggleColumn(column, $event)"
          />
        </div>
      }
    </div>
    @if (showColumnChooserSpinner()) {
      <div class="sia-flex-center sia-blur !absolute">
        <mat-spinner></mat-spinner>
      </div>
    }
  </div>
</div>

<mat-menu #views="matMenu">
  @if (gridConfigurations().length == 1) {
    <button
      mat-menu-item
      (click)="selectedGridView.set(gridConfigurations()[0])"
      role="menuitemcheckbox"
    >
      <mat-checkbox
        [checked]="selectedGridView()?.id == gridConfigurations()[0].id"
      ></mat-checkbox>
      -{{ gridConfigurations()[0].description | siaTranslate }}-
    </button>
  }
  @for (view of gridViews(); track view.id) {
    <button mat-menu-item (click)="selectedGridView.set(view)">
      <mat-checkbox
        [checked]="selectedGridView()?.id == view.id"
      ></mat-checkbox>
      {{ view.description }}
    </button>
  }

  @if (gridConfigurations().length > 1) {
    @for (configuration of gridConfigurations(); track configuration.id) {
      <button mat-menu-item (click)="selectedGridView.set(configuration)">
        <mat-checkbox
          [checked]="selectedGridView()?.id == configuration.id"
        ></mat-checkbox>
        {{ configuration.description }}
      </button>
    }
  }
</mat-menu>
